<template>
  <v-container fluid>
    <v-row wrap align-center>
      <v-col cols=12>
        <div class="text-center">
          <h1 class="headline font-weight-medium">
            {{ $vuetify.lang.t(`$vuetify.landing.patents.title`) }}
          </h1>
        </div>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" md="4">
        <v-card flat color="transparent" elevation="10" max-width="500" class="mx-auto" shaped
                href="http://www1.fips.ru/registers-doc-view/fips_servlet?DB=RUPAT&DocNumber=2703341&TypeFile=html">
          <v-img contain max-width="500" :src="require('@/assets/landing/patents/pat_01.jpg')" eager></v-img>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card flat color="transparent" elevation="10" max-width="500" class="mx-auto" shaped
                href="http://www1.fips.ru/registers-doc-view/fips_servlet?DB=EVM&DocNumber=2017614256&TypeFile=html">
          <v-img contain max-width="500" :src="require('@/assets/landing/patents/pat_02.jpg')" eager></v-img>
        </v-card>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="pt-2 pb-0">
      <v-btn :to="{name: 'corpus'}">Corpus</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import metaMixin from '../../mixins/metaMixin'

export default {
  name: 'patentsSlide',
  mixins: [metaMixin],
  metaInfo: {
    title: 'Drive Safely | Intellectual property',
    meta: [
      { name: 'description', content: 'Drive safely intellectual property' },
      { property: 'og:title', content: 'Drive Safely Int. property' },
      { property: 'og:site_name', content: 'Drive Safely' },
      { property: 'og:description', content: 'Drive safely intellectual property' },
      { property: 'og:url', content: 'https://mobiledrivesafely.com/patents' }
    ]
  }
}
</script>

<style scoped>

</style>
